import { makeStyles } from '@material-ui/styles';

export const useAttachmentCardStyles = makeStyles((theme) => ({
  gridElement: {
    padding: theme.spacing(1, 0),
    width: '100%',
  },
  paper: {
    width: '100%',
    padding: theme.spacing(2),
    boxShadow:
      '2px 2px 1px 0px rgba(0, 0, 0, 0.2), 0px 1px 1px 2px rgba(0,0,0,0.14), 0px 1px 1px 0px rgba(0,0,0,0.12)',
  },
  card: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: theme.spacing(2),
    width: '100%',
  },
  mediaSection: {
    flex: '0 0 120px',
    width: 120,
    height: 120,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.up('sm')]: {
      flex: '0 0 146px',
      width: 146,
      height: 146,
    },
  },
  pdfIcon: {
    fontSize: 60,
  },
  img: {
    maxWidth: '100%',
    maxHeight: '100%',
    objectFit: 'contain',
  },
  contentSection: {
    flex: '1 1 220px',
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
    textAlign: 'left',
    gap: theme.spacing(1),
    [theme.breakpoints.down('xs')]: {
      flex: '1 1 100%',
    },
  },
  textField: {
    width: '100%',
  },
  truncatedText: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: 'block',
    width: '100%',
    maxWidth: '100%',
    textAlign: 'left',
  },
  footerRow: {
    minHeight: 36,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    width: '100%',
  },
  viewButton: {
    whiteSpace: 'nowrap',
  },
  actionsSection: {
    flex: '0 0 auto',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: theme.spacing(0.5),
    marginLeft: 'auto',
    alignSelf: 'center',
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      marginLeft: 0,
      justifyContent: 'flex-end',
    },
  },
}));
